import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["fieldTypeSelect", "optionsField", "areaLevelField"]

  connect() {
    this.toggleFields()
  }

  toggleFields() {
    const fieldType = this.fieldTypeSelectTarget.value
    const dropdownTypes = ['single_dropdown', 'multi_dropdown', 'radio_button']

    // Show/hide options field
    if (dropdownTypes.includes(fieldType)) {
      this.optionsFieldTarget.classList.remove('hidden')
    } else {
      this.optionsFieldTarget.classList.add('hidden')
    }

    // Show/hide area level field
    if (fieldType === 'area') {
      this.areaLevelFieldTarget.classList.remove('hidden')
    } else {
      this.areaLevelFieldTarget.classList.add('hidden')
    }
  }
}
